import { render, staticRenderFns } from "./selfpay.vue?vue&type=template&id=2ea7d74c&scoped=true"
import script from "./selfpay.vue?vue&type=script&lang=js"
export * from "./selfpay.vue?vue&type=script&lang=js"
import style0 from "./selfpay.vue?vue&type=style&index=0&id=2ea7d74c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea7d74c",
  null
  
)

export default component.exports